export type StocktakeStatus = 'DRAFT' | 'PENDING_APPROVAL' | 'POSTED' | 'CANCELLED';

export const STOCKTAKE_STATUS_LABELS: Record<StocktakeStatus, string> = {
    DRAFT: 'Draft',
    PENDING_APPROVAL: 'Pending Approval',
    POSTED: 'Posted',
    CANCELLED: 'Cancelled',
};

export interface StocktakeLineDTO {
    id: string;
    stocktakeId: string;
    itemId: string;
    itemName: string;
    itemCode: string;
    systemQty: number;
    countedQty: number | null;
    unitCost: number | null;
    variance: number;
    segmentId?: string | null;
}

export interface StocktakeDTO {
    selfApproved?: boolean;
    selfApprovalRule?: string | null;
    id: string;
    referenceNo: string;
    storeId: string;
    storeName: string;
    institutionId: string;
    status: StocktakeStatus;
    stocktakeDate: string;
    approvedById: string | null;
    approvedDate: string | null;
    postedDate: string | null;
    journalEntryId: string | null;
    notes: string | null;
    lines: StocktakeLineDTO[];
}

export interface StocktakeCreateDTO {
    storeId: string;
    institutionId: string;
    stocktakeDate?: string;
    notes?: string;
}

export interface StocktakeCountDTO {
    lineId: string;
    countedQty: number;
    unitCost?: number;
    segmentId?: string;
    /** F6b: for a serial-tracked item, the full list of serials counted on the shelf. */
    serials?: string[];
}

export interface StocktakeResponse {
    content: StocktakeDTO[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        sort: {
            sorted: boolean;
            empty: boolean;
            unsorted: boolean;
        };
        offset: number;
        paged: boolean;
        unpaged: boolean;
    };
    last: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    sort: {
        sorted: boolean;
        empty: boolean;
        unsorted: boolean;
    };
    numberOfElements: number;
    first: boolean;
    empty: boolean;
}
